import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { agtApiKey, getApiToken, custApiKey,dateFm, strToArray } from '../../inc/myFunctions';
import API from "../../inc/axios";

function ViewTransaction() {
    const navigate = useNavigate();
    const location = useLocation();
    const [errors, setErrors] = useState({});
    const [getData, setData] = useState(null);
    const pid = location.state;
    async function getCustDocsData(pid) {
        const newErrors = {};
        const formData = {
            agt_api_key: agtApiKey(),
            cust_api_key: custApiKey(),
            pin_code: pid
        }
        try {
            if (pid === "" || pid === null || typeof pid === "undefined") {
                newErrors.app_error = "Invalid Request";
                setErrors(newErrors);
                navigate("/Transaction")
                return;
            }
            const token = await getApiToken("Yes");
            const config = { headers: { Authorization: `Bearer ` + token } }
            const response = await API.post('/transactions/trans.php?api_action=getTransDetail', JSON.stringify(formData), config);
            if (response.status === 200 && response.data.status_code === 1000) {
                const rs = response.data.trans;
                console.log(rs)
                setData(rs)
            } else {
                if (typeof response.data.status_msg === "undefined") {
                    console.log(response)
                    newErrors.app_error = "No Data Found";
                } else {
                    newErrors.app_error = response.data.status_msg;
                }
                setErrors(newErrors);
                return;
            }
        } catch (error) {
            console.error(error);
        }

    }
    useEffect(() => {
        if (typeof pid != "undefined" && pid != null) {
            getCustDocsData(location.state.pid)
        } else {
            navigate("/CustomerDocs")
        }

    }, []);

    return (
        <div className="container-fuild app-main-card onboard-card">
            <div className="container mx-width">
                <h4 className="app-title">Transaction Detail</h4>
            </div>
            <div className="container p-0 mx-width">
                {errors.app_error && <div className="invalid-feedback" style={{ display: "block" }}>{errors.app_error}</div>}
                {getData ? (
                    <div className="container-fluid p-0">
                        <div className="row m-0">
                            <div className="col-12  mb-3">
                                <ul className="list-group list-group-flush app-list">
                                    <li className="list-group-item"><p>ID</p><p>{getData.pin_code}</p></li>
                                    <li className="list-group-item"><p>Date</p><p>{dateFm(getData.trans_date)}</p></li>
                                    <li className="list-group-item"><p>Status</p><p>{getData.trans_status}</p></li>
                                    <li className="list-group-item"><p>Compliance</p><p>{strToArray(getData.compliance_alert).map((rs,index)=>(<span key={index} className="badge bg-danger me-1">{rs}</span>))}</p></li>
                                    <li className="list-group-item"><p>Beneficiary</p><p>{getData.bene_name}</p></li>
                                    <li className="list-group-item"><p>Company</p><p>{getData.payout_comp_name}</p></li>
                                    <li className="list-group-item"><p>Pay Amount</p><p>{getData.pay_in_amt} {getData.pay_in_cur}</p></li>
                                    <li className="list-group-item"><p>Exchange Rate</p><p>{getData.exch_rate}</p></li>
                                    <li className="list-group-item"><p>Exchange Charges</p><p>{getData.exch_charges}</p></li>
                                    <li className="list-group-item"><p>Pay Out Amount</p><p>{getData.pay_out_amt} {getData.pay_out_cur}</p></li>
                                    <li className="list-group-item"><p>Payment Status</p><p>{getData.payment_status}</p></li>
                                    <li className="list-group-item"><p>Pay Out Company</p><p>{getData.payout_comp_name}</p></li>
                                    <li className="list-group-item"><p>Pay Out Country</p><p>{getData.payout_country}</p></li>
                                    <li className="list-group-item"><p>Pay Out Type</p><p>{getData.payout_type}</p></li>
                                    <li className="list-group-item"><p>Transaction Purpose</p><p>{getData.trans_purpose}</p></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                ) : (
                    errors.app_error ? errors.app_error && (<div></div>) : (
                        <>
                            <div className="col-12 mb-3 placeholder-glow">
                                <div className="input-group">
                                    <span className="placeholder col-12 mb-4" style={{ height: "59px" }}></span>
                                </div>
                            </div>
                            <div className="col-12 mb-3 placeholder-glow">
                                <div className="input-group">
                                    <span className="placeholder col-12 mb-4" style={{ height: "59px" }}></span>
                                </div>
                            </div>
                            <div className="col-12 mb-3 placeholder-glow">
                                <div className="input-group">
                                    <span className="placeholder col-12 mb-4" style={{ height: "59px" }}></span>
                                </div>
                            </div>
                            <div className="col-12 mb-3 placeholder-glow">
                                <div className="input-group">
                                    <span className="placeholder col-12 mb-4" style={{ height: "59px" }}></span>
                                </div>
                            </div>
                            <div className="col-12 mb-3 placeholder-glow">
                                <div className="input-group">
                                    <span className="placeholder col-12 mb-4" style={{ height: "59px" }}></span>
                                </div>
                            </div>
                        </>
                    )
                )}
            </div>
        </div>

    );
}

export default ViewTransaction;
